"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
require("./root-style.scss");
const login_page_1 = require("./page/login-page/login-page");
const main_page_1 = require("./page/main-page/main-page");
const local_storage_1 = require("./utils/local-storage");
const input_validation_1 = require("./page/login-page/input-validation");
class App {
    constructor() {
        this.container = document.body;
    }
    renderPage(pageId) {
        this.container.innerHTML = '';
        let page = null;
        switch (pageId) {
            case 'main-page':
                page = new main_page_1.MainPage(pageId);
                break;
            default:
                if ((0, local_storage_1.checkLogin)()) {
                    page = new main_page_1.MainPage('main-page');
                    (0, main_page_1.showGreeting)();
                }
                else {
                    page = new login_page_1.LoginPage(pageId);
                }
                break;
        }
        if (page) {
            const pageHTML = page.render();
            this.container.append(pageHTML);
        }
    }
    run(page = 'login-page') {
        this.renderPage(page);
        if (page === 'login-page') {
            (0, input_validation_1.inputValidation)();
        }
        else {
            (0, main_page_1.showGreeting)();
        }
    }
}
exports.App = App;
